import { render } from "./ImportarXmlPage.vue?vue&type=template&id=7d6740cb&scoped=true"
import script from "./ImportarXmlPage.vue?vue&type=script&lang=js"
export * from "./ImportarXmlPage.vue?vue&type=script&lang=js"

import "./ImportarXmlPage.vue?vue&type=style&index=0&id=7d6740cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6740cb"]])

export default __exports__